import LoadingSpinner from './LoadingSpinner';

export default LoadingSpinner; 